import { render } from "./HeaderNotificacoesMobile.vue?vue&type=template&id=709e1ac5&scoped=true"
import script from "./HeaderNotificacoesMobile.vue?vue&type=script&lang=js"
export * from "./HeaderNotificacoesMobile.vue?vue&type=script&lang=js"

import "./HeaderNotificacoesMobile.vue?vue&type=style&index=0&id=709e1ac5&scoped=true&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709e1ac5"]])

export default __exports__